import { defineStore } from 'pinia'

const STORAGE_KEY = 'market_developer_mode'
const CLICK_WINDOW_MS = 2500
const REQUIRED_CLICKS = 5

function readStoredMode(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1'
  } catch {
    return false
  }
}

export const useDeveloperModeStore = defineStore('developerMode', {
  state: () => ({
    enabled: readStoredMode(),
    clickCount: 0,
    lastClickAt: 0
  }),
  getters: {
    isEnabled(state): boolean {
      return state.enabled
    }
  },
  actions: {
    setEnabled(value: boolean) {
      this.enabled = value
      try {
        if (value) localStorage.setItem(STORAGE_KEY, '1')
        else localStorage.removeItem(STORAGE_KEY)
      } catch {
        // ignore storage errors
      }
    },
    toggle() {
      this.setEnabled(!this.enabled)
      return this.enabled
    },
    /** Returns true when the gesture toggled the mode. */
    registerLogoClick(): boolean {
      const now = Date.now()
      if (now - this.lastClickAt > CLICK_WINDOW_MS) {
        this.clickCount = 0
      }
      this.lastClickAt = now
      this.clickCount += 1

      if (this.clickCount >= REQUIRED_CLICKS) {
        this.clickCount = 0
        this.toggle()
        return true
      }
      return false
    }
  }
})
